import React, {useState, useEffect, useRef} from 'react';
import './App.css';
import Navbar from './components/navbar/navbar.js';
import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import Home from './components/home/home.js';
import Feed from './components/feed/feed.js';
import Login from './components/login/login.js';
import Profile from './components/profile/profile.js';
import SpecificProfile from './components/specificProfile/specificProfile.js';
import firebase from './config/fbConfig.js'

const auth = firebase.auth();

function App() {
	console.log('check');
	const [user, setUser] = useState(null)
	const isPhone = useRef(false)

	useEffect(() => {
		isPhone.current = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		auth.onAuthStateChanged(user => {
		if (user) {
			setUser(user);
		} else {
			setUser(null);
		}

		})
	}, [])
	
  return (
    <div className="App">

	    <BrowserRouter>
	     	 <Navbar user={user}/>
	     	 <Switch>
		     	 <Route exact path='/' component={Home}/>
		     	 <Route path='/feed' render={(props) => <Feed {...props} user={user} isPhone={isPhone}/>} />
		     	 <Route path='/login' render={(props) => <Login {...props} isPhone={isPhone}/>} />
		     	 <Route exact path='/profile' render={(props) => <Profile {...props} user={user} isPhone={isPhone}/>} />
		     	 <Route path='/profile/:profile_id' render={(props) => <SpecificProfile {...props} user={user} isPhone={isPhone} />} />
		     	 <Redirect to="/" />
	     	 </Switch>
	     </BrowserRouter>

    </div>
  );
}

export default App;
